import { useEffect, useState } from 'react';
import { onSessionExpired, refreshAccessToken } from '../services/refreshService';

export const useSessionExpiration = () => {
    const [isSessionExpired, setIsSessionExpired] = useState(false);

    useEffect(() => {
        // Registramos el callback para cuando la sesión expire.
        onSessionExpired(() => setIsSessionExpired(true));
    }, []);

    useEffect(() => {
        // Función que intenta refrescar el token usando la cookie httpOnly.
        const checkExpiration = async () => {
            try {
                await refreshAccessToken();
            } catch (error) {
                console.error('Error al refrescar el token. La sesión puede haber expirado.', error);
            }
        };

        // Verificamos inmediatamente la validez del token.
        checkExpiration();
        // Establecemos un intervalo para verificar cada minuto.
        const interval = setInterval(checkExpiration, 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    return { isSessionExpired, setIsSessionExpired };
};